<script>
    import Calculator from 'views/components/calculator/Calculator.svelte';
    import Icon from 'views/components/icon/Icon.svelte';

    function onClick() {
        const container = new BaseView()
        container.addSvelteChildView(
            container.el,
            Calculator,
        )
        Backbone.View.sidebar.showSidebar(
            container,
            window.i18n.gettext('Calculator'),
            320,
            undefined,
            window.innerWidth > 960,
        )
    }
</script>

<button class="calculator-button no-print" on:click={onClick}>
    <Icon name="calculator"></Icon>
    <div class="tooltip">
        {window.i18n.gettext('Calculator')}
    </div>
</button>

<style lang="scss">
    .calculator-button {
        @include box-shadow;

        position: fixed;
        bottom: 16px;
        right: 64px;
        display: flex;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: $blue;
        color: $white;
        transition: all ease-out 0.1s;
        animation: 0.3s fadeIn ease-out;

        @keyframes fadeIn {
            0% { opacity: 0; }
        }

        @media (max-width: 1200px) {
            right: 64px;
            width: 48px;
            height: 48px;
        }

        @media (max-width: 620px) {
            display: none;
        }

        &:hover {
            background: $blue-dark;
            transform: scale(1.1);

            @media (hover: hover) {
                .tooltip {
                    display: block;
                }
            }
        }

        :global(svg) {
            width: 32px;
            height: 32px;
            margin: auto;
            fill: currentColor;

            @media (max-width: 1200px) {
                width: 24px;
                height: 24px;
            }
        }

        .tooltip {
            display: none;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateX(-100%) translateX(-8px) translateY(-50%);
            padding: 4px 8px;
            border-radius: 8px;
            background: $blue-black;
        }
    }
</style>
